import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { IMultiSelectSettings } from '../multi-select/models/multi-select-settings.interface';
import { IOption } from '../multi-select/models/option.interface';
import { CustomControlValueAccessor } from '../../utils/custom-control-value-accessor/custom-control-value-accessor';
import { OperacaoVenda } from '../../../../home/pedido/domain';

@Component({
  selector: 'sgt-novo-operacao-venda-multiselect',
  templateUrl: './novo-operacao-venda-multiselect.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NovoOperacaoVendaMultiselectComponent),
      multi: true
    }
  ]
})
export class NovoOperacaoVendaMultiselectComponent
  extends CustomControlValueAccessor<number[]>
  implements OnInit {
  @Input() idsOperacoesVenda: number[];
  @Output() idsOperacoesVendaChange = new EventEmitter<number[]>();

  settings: IMultiSelectSettings = {
    placeholder: 'Selecione as operações de venda',
    plural: 'Operações de Venda',
    singular: 'Operação de Venda',
    searchEmptyResultMessage: 'Nenhuma operação de venda encontrada',
    showFooter: false
  };

  options: IOption[] = [];

  constructor() {
    super();
  }

  ngOnInit() {
    this.create();
  }

  private create() {
    const selects: IOption[] = [];

    OperacaoVenda.getAll().forEach((operacaoVenda) => {
      selects.push({
        id: operacaoVenda.id,
        label: operacaoVenda.nome
      });
    });

    this.options = selects;
  }

  protected updateValue(newValue: number[] | null): void {
    this.idsOperacoesVenda = newValue;
  }

  onSearch() {
    this.idsOperacoesVendaChange.emit(this.idsOperacoesVenda);
  }

  onChangeOperacoesVenda() {
    this.emitChange(this.idsOperacoesVenda);
    this.markAsTouched();
  }
}
